<script lang="ts" setup>
  import type { RadioGroup } from '@/components/ui/radio/types'
  import { cva } from 'class-variance-authority'

  const props = withDefaults(defineProps<RadioGroup>(), {
    name: '',
    hasError: false,
    direction: 'column',
    variant: 'white'
  })

  const radioState = defineModel<string>()
  const instance = getCurrentInstance()
  const groupId = instance?.uid ?? 'default'

  const onUpdate = (value: string) => {
    radioState.value = value
  }

  const variantStyle = computed(() =>
    cva('flex w-fit items-center gap-2 sm:gap-4 lg:gap-6', {
      variants: {
        variant: {
          white: 'text-white md:text-bt-blue-dark',
          primary: 'md:text-bt-blue-dark'
        }
      }
    })({
      variant: props.variant
    })
  )
</script>
<template>
  <RadioGroupRoot
    v-model="radioState"
    class="group flex gap-x-4 gap-y-6"
    :class="[{ 'has-error': hasError }, direction === 'row' ? 'flex-row' : 'flex-col']"
    :aria-label="ariaLabel || name"
    @update:model-value="onUpdate"
  >
    <div
      v-for="(item, index) in items"
      :key="`radioItem-${name}-${index}`"
      class="flex items-center gap-4"
    >
      <UiRadioItem
        :selected="radioState === item.value"
        :item="item"
        :id-prefix="name || `radio-group-${groupId}`"
        :id-suffix="index"
        :class="variantStyle"
      />
    </div>
  </RadioGroupRoot>
</template>
